import React, { useContext } from 'react'
import { rootStoreContext } from '@app/components/App'
import { observer } from 'mobx-react-lite'
import { InfoIcon } from '@app/components/InfoIcon'
import { WikipediaIcon } from '@app/components/WikipediaIcon'
import { Range } from '@app/components/Range'

export const TrackSelect = observer(() => {
  const rootStore = useContext(rootStoreContext)

  return (
    <div className="pt-8 pb-2">
      <h3 className="text-sm uppercase text-gray-600 font-normal pl-1 lg:pl-6 -mb-1">
        Formula One Statistics - Choose a race and year
      </h3>
      <div className="text-2xl lg:text-3xl text-charcoal flex flex-col lg:flex-row lg:items-end -ml-1">
        <span
          className="cursor-pointer hover:text-blue-600 font-semibold pl-2 lg:pl-0 py-2 lg:py-0 flex flex-row"
          onClick={() => {
            rootStore.trackSelectOpen = true
          }}
        >
          <span
            className="text-xl inline-block w-7 relative"
            style={{
              alignSelf: 'center',
            }}
          >
            ☰
          </span>
          <span className="inline-block leading-tight">
            {rootStore.selectedTrack.name}
          </span>
        </span>
        <span className="ml-2 lg:ml-4 flex items-center">
          <span className="text-xl font-light text-gray-700 lg:text-right">
            {rootStore.selectedYear}
          </span>
          <span
            className="inline-block pr-2"
            style={{
              width: `${Math.min(
                256,
                (rootStore.maxYear - rootStore.minYear) * 32
              )}px`,
            }}
          >
            <Range
              min={rootStore.minYear}
              max={rootStore.maxYear}
              value={rootStore.selectedYear}
              onChange={value => (rootStore.selectedYear = value)}
            />
          </span>
        </span>
        <a
          className="text-blue-700 text-sm py-1 pl-2 lg:pl-0 mt-4 lg:mt-0 flex items-center"
          target="_blank"
          rel="noopener noreferrer"
          href={`https://en.wikipedia.org/wiki/${
            rootStore.selectedYear
          }_${rootStore.selectedTrack.name.replace(' ', '_')}`}
        >
          <WikipediaIcon />
          Wikipedia entry for this race
        </a>
        <span className="mr-auto lg:mr-3 lg:ml-auto text-blue-700 text-sm pt-1 pl-2 lg:pl-4 mt-4 lg:mt-0">
          <span
            onClick={() => {
              rootStore.helpOpen = true
            }}
            className="flex bg-gray-200 whitespace-no-wrap items-center cursor-pointer hover:bg-gray-100"
            style={{
              borderRadius: '1rem',
              padding: '0.1rem 0.75rem 0.1rem 0.5rem',
            }}
          >
            <InfoIcon />
            <span className="pl-2">How to use</span>
          </span>
        </span>
      </div>
    </div>
  )
})
